import {
  useProjectContext,
  useProjectDispatch
} from "components/project/projects/context";

import {
  IUseCreateProjectShapefileFolderMutation,
  useCreateProjectShapefileFolderMutation
} from "../../mutations";

export const useCreateProjectShapefileFolder = (
  params: IUseCreateProjectShapefileFolderMutation
) => {
  const projectDispatch = useProjectDispatch();

  const { selectedProjectId, layerTreeExpandedKeys } = useProjectContext();

  const createProjectShapefileFolderMutation = useCreateProjectShapefileFolderMutation({
    projectId: params.projectId || selectedProjectId,
    onSuccess: (data, variables) => {
      const { parentId } = variables;

      projectDispatch({
        payload: {
          layerTreeExpandedKeys: [...layerTreeExpandedKeys, parentId],
          newlyCreatedFolderId: data.data.shapefileNodeId,
          isTreeDraggable: false
        }
      });
    }
  });

  return createProjectShapefileFolderMutation;
};
